import React from 'react';
import { m } from 'framer-motion';
import { Col } from 'react-bootstrap';

const ProjectComponentsDetails = () => {
	return (
		<m.div className="container  mt-[200px] ">
			<Col xl={8} lg={10} className="text-center mt-[200px] w-fit">
				<h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">
					Leadership
				</h3>
				<m.div
					className="border-b border-1 w-[40%] border-[#146084]"
					initial={{ scaleX: 0 }}
					animate={{ scaleX: 1 }}
					transition={{ duration: 0.5, delay: 0.2 }}
				/>
			</Col>
			{/* Main Image Section */}
			<div className="mb-8 mt-2">
				<img
					src="/path/to/main-image.jpg"
					alt="KERA Project"
					className="w-full h-[400px] object-cover rounded-lg shadow-lg"
					onError={e => {
						e.target.src = '/images/Agro Park.webp';
					}}
				/>
			</div>

			{/* Main Title */}
			<div className="text-center mb-10">
				<h2 className="text-3xl font-semibold text-gray-800 mb-3">
					KERA Project Components
				</h2>
				<p className="text-base text-gray-600 max-w-4xl mx-auto">
					Transforming Kerala's agricultural landscape through innovative
					solutions, strategic partnerships, and comprehensive support systems
					for sustainable growth
				</p>
			</div>

			<hr className="my-10 border-t-2 border-gray-300" />

			{/* Component 3.1 */}
			<hr className="my-10 border-t-2 border-gray-300" />

			{/* Component 3.1 */}
			<div className="mb-10">
				<h3 className="text-[30px] font-semibold text-gray-800 mb-4">
					KERA Project Subcomponent 3.1 – Support for Agri-Food MSMEs
				</h3>

				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					India's agri-food processing sector is one of the fastest-growing
					industries, contributing significantly to GDP and rural employment.
					With rising demand for safe, value-added, and export-ready food
					products, the sector has become a key driver of entrepreneurship and
					innovation. Kerala, with its rich agricultural base and strong export
					linkages, holds a unique advantage in crops such as rice, spices,
					coconut, banana, jackfruit, cashew, coffee, and more. The state
					contributes nearly 20% of India's food processing growth, supported by
					its thriving hospitality, tourism, and overseas markets (especially
					the Middle East).
				</p>

				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					For Kerala's 16,000+ agri-food MSMEs, this presents a tremendous
					opportunity to scale up, modernize, and capture both domestic and
					international markets. Under Subcomponent 3.1 of KERA project, the
					project focuses on enhancing the competitiveness and growth of
					Agri-Food MSMEs.
				</p>

				<h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
					Who Can Apply?
				</h4>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>
						Small and Medium Enterprises (SMEs) in the agri-food sector in
						Kerala.
					</li>
					<li>
						Units engaged in food processing, value addition, or agri-based
						manufacturing/services.
					</li>
					<li>
						Enterprises that have been in operation for at least 3 years with
						valid Udyam registration, GST, and IT returns.
					</li>
				</ul>

				<h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
					What Support Will You Get?
				</h4>
				<p className="text-gray-700 mb-2">Selected MSMEs will receive:</p>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Financial Grants (up to 80%) for:
				</h5>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>
						Adoption of greener technologies (energy efficiency, waste
						management).
					</li>
					<li>
						Strengthening backward linkages with farmers (collection/processing
						units).
					</li>
					<li>
						Market development (participation in national/international expos,
						export trials).
					</li>
					<li>
						Certifications for food safety, quality, energy, or export
						standards.
					</li>
					<li>Specialized training and skill development.</li>
				</ul>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Capacity Building & Training
				</h5>
				<p className="text-gray-700 mb-4">
					In entrepreneurship, new technologies, exports, and business planning.
				</p>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Technical Support
				</h5>
				<p className="text-gray-700 mb-4">
					From experts for business development, technology adoption, and market
					linkages.
				</p>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Market Linkages & Export Support
				</h5>
				<p className="text-gray-700 mb-4">
					Including protocols for priority crops and access to e-commerce
					platforms.
				</p>

				<h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
					Grant Pattern
				</h4>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>
						Up to 80% grant for green technologies, backward linkages, markets,
						and certifications.
					</li>
					<li>60% grant for specialized training.</li>
					<li>40% grant for infrastructure expansion and modernization.</li>
					<li>(Disbursement will be on a reimbursement basis.)</li>
				</ul>

				<h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
					Target
				</h4>
				<p className="text-gray-700 mb-4">
					250 high-growth Agri-Food SMEs will be selected and supported over 3
					years (50 in Year 1, 100 in Year 2, and 100 in Year 3).
				</p>

				<h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
					How to Apply?
				</h4>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>Applications will be invited through the KERA online portal.</li>
					<li>
						Eligible MSMEs must submit proposals with a business plan/DPR.
					</li>
					<li>
						Selection will be based on transparent evaluation criteria including
						turnover, growth, certifications, employment generation, and women
						leadership.
					</li>
				</ul>

				<h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
					Why Participate?
				</h4>
				<p className="text-gray-700 mb-2">
					By joining the KERA Project, your enterprise can:
				</p>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>Upgrade to modern, sustainable technologies.</li>
					<li>Expand to national and international markets.</li>
					<li>Improve quality, efficiency, and competitiveness.</li>
					<li>Create more jobs and build stronger linkages with farmers.</li>
				</ul>
			</div>

			<hr className="my-10 border-t-2 border-gray-300" />

			{/* Component 3.2 */}
			<div className="mb-10">
				<h3 className="text-[30px] font-semibold text-gray-800 mb-4">
					KERA Project Subcomponent 3.2 – Support technology incubation and
					Agri-based hi-tech start-ups with adoption by end users
				</h3>

				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					Imagine a young innovator with a brilliant idea for a drone that can
					spot crop diseases early, or an app that connects farmers directly to
					buyers, cutting out middlemen. How do they turn that idea into a
					reality that benefits thousands of farmers across Kerala?
				</p>

				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					This is the core mission of KERA's Subcomponent 3.2. In a strategic
					partnership with the renowned Kerala Start-Up Mission (KSUM), we are
					launching an initiative to find, fund, and foster the next generation
					of agricultural technology (agri-tech) leaders. Our goal is to create
					a vibrant ecosystem where technology solves real-world agricultural
					challenges, making farming more efficient, profitable, and
					sustainable.
				</p>

				<h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
					Our Strategy for Innovation:
				</h4>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Solving Real-World Problems:
				</h5>
				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					We don't start with technology; we start by listening. We organize
					workshops across Kerala to hear directly from farmers, FPOs, and local
					businesses to identify their most pressing challenges—from pest
					management to supply chain gaps. These "problem statements" become the
					core focus of our call for innovation.
				</p>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Funding for the Boldest Ideas:
				</h5>
				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					We are selecting 150 high-potential startups and providing them with
					substantial financial backing to build and scale their solutions. Each
					selected startup is eligible for a grant of up to ₹25 lakhs,
					structured to support their entire journey:
				</p>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>
						₹20 Lakhs for Product Development: This initial grant fuels the
						critical early stages, covering research, prototype development,
						technology commercialization, and working capital.
					</li>
					<li>
						₹5 Lakhs for Market Adoption: Once the product is ready, this second
						grant helps with marketing, product demonstrations, and pilot
						launches to ensure the technology reaches the farmers and businesses
						who need it.
					</li>
				</ul>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					A 360° Support System:
				</h5>
				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					Beyond funding, our startups gain access to a complete support
					ecosystem designed for success. This includes rent-free office space,
					expert mentoring sessions, capacity-building workshops on topics like
					financial management and business strategy, and even Global & National
					Market Immersion Programs to connect with international markets and
					investors.
				</p>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Measuring Success by Impact:
				</h5>
				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					Our ultimate goal is widespread adoption. This initiative will be a
					success when 40,000 farmers and agri-businesses are actively using
					these new technologies to improve their productivity, profitability,
					and resilience. The entire component is managed under a
					Performance-Based Condition (PBC) framework, meaning funds are linked
					directly to achieving these ambitious targets, ensuring accountability
					and a sharp focus on results.
				</p>

				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					This is more than a funding program; it's a mission to build a
					self-sustaining agri-tech ecosystem in Kerala, where local innovation
					solves local problems and creates global opportunities.
				</p>
			</div>

			<hr className="my-10 border-t-2 border-gray-300" />

			{/* Component 3.3 */}
			<div className="mb-10">
				<h3 className="text-[30px] font-semibold text-gray-800 mb-4">
					KERA Project Subcomponent 3.3 – Support for the establishment of Agri
					& food parks at differing scale in several locations across Kerala
				</h3>

				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					Did you know that an estimated 15-20% of Kerala's agricultural produce
					is lost after harvest due to a lack of proper storage, transport, and
					processing facilities? This represents a massive loss of income for
					our farmers and a missed opportunity for our state's economy.
					Subcomponent 3.3 tackles this challenge head-on by investing in the
					creation of state-of-the-art Agri-Food Parks and processing centres
					across Kerala.
				</p>

				<h4 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
					Our Plan for Transformation:
				</h4>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Creating Hubs of Excellence:
				</h5>
				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					We are establishing a network of large, medium, and small-scale
					Agri-Food Parks. These are not just industrial plots; they are
					fully-equipped ecosystems with ready-to-use facilities like common
					processing centers, cold storage, warehouses, and quality control
					labs. This "plug-and-play" model drastically reduces the investment
					and risk for entrepreneurs, making it easier for them to set up modern
					food processing businesses.
				</p>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Strategic Partnerships for Expert Execution:
				</h5>
				<p className="text-gray-700 mb-4">
					To ensure these parks are world-class, we are partnering with expert
					agencies.
				</p>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>
						<strong>Model 1:</strong> The Kerala Industrial Infrastructure
						Development Corporation (KINFRA) will develop and operate facilities
						on its land.
					</li>
					<li>
						<strong>Model 2:</strong> For parks on Department of Agriculture
						land, the KERA project team will lead development with technical
						guidance from KINFRA and implementation support from a Special
						Purpose Vehicle under the Agriculture Department.
					</li>
				</ul>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Proposed Locations Under Study:
				</h5>
				<p className="text-gray-700 mb-4">
					Pre-feasibility studies are currently underway to finalize the most
					viable locations. Potential sites being evaluated include:
				</p>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>Kannur: At the KINFRA Industrial Park in Mattanur.</li>
					<li>Kollam: At the District Agricultural Farm in Anchal.</li>
					<li>
						Palakkad: At the Central Orchard in Pattambi and the KINFRA Mega
						Food Park in Kozhipara.
					</li>
					<li>Thrissur: At the Krishi Vigyan Kendra in Vellanikkara.</li>
					<li>
						Ernakulam: At the Rural Agricultural Wholesale Market in
						Muvattupuzha.
					</li>
					<li>Kasaragod: At the College of Agriculture.</li>
				</ul>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Revitalizing Existing Assets:
				</h5>
				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					Our plan isn't just about building new facilities. We will also focus
					on operationalizing five existing Common Processing Centres (CPCs)
					that are currently stalled, turning dormant assets into productive
					hubs. Furthermore, we will support the revamping of key Public Sector
					Undertakings (PSUs) to improve their operational efficiency and
					business activities.
				</p>

				<h5 className="text-base font-semibold text-gray-800 mt-4 mb-2">
					Driving Economic Growth:
				</h5>
				<p className="text-gray-700 mb-4">
					These parks are powerful engines for economic development. By creating
					a strong link between farms and processing units, we will:
				</p>
				<ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 ml-4">
					<li>
						Attract significant private investment into Kerala's food sector.
					</li>
					<li>
						Create thousands of new, sustainable jobs, with a special focus on
						empowering women and local communities.
					</li>
					<li>
						Drastically reduce post-harvest losses and enhance value addition.
					</li>
					<li>
						Increase farmer incomes by providing a reliable and competitive
						market for their produce.
					</li>
				</ul>

				<p className="text-gray-700 mb-4 text-justify leading-relaxed">
					Through this component, we are laying the foundation for Kerala to
					become a national leader in value-added agriculture and food
					processing, turning our rich farm bounty into globally competitive
					products.
				</p>
			</div>
		</m.div>
	);
};

export default ProjectComponentsDetails;
